export default __webpack_public_path__ + "static/ABA_2021-Finalist__COMMERCIAL BROKER OF THE YEAR-de6f6767e0aaea82f9e6ecfbfad9b1e9.png";